import {
    Card,
    CardBody,
    CardHeader,
    Table,
    Badge,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheck,
    faHistory,
    faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { formatDate } from '../admin.utils';

const DEFAULT_MAX_ROWS = 10;

export const ExecutionHistory = ({
    usageHistory,
    children,
    renderDetails,
    maxRows = DEFAULT_MAX_ROWS,
}) => {
    const displayedHistory = usageHistory.slice(0, maxRows);
    const hasMore = usageHistory.length > maxRows;
    const renderRecordDetails = renderDetails ?? children;

    return (
        <Card className="shadow-sm mt-4">
            <CardHeader className="bg-white">
                <h5 className="mb-0 d-flex align-items-center">
                    <FontAwesomeIcon
                        icon={faHistory}
                        className="mr-2 text-secondary"
                    />
                    Execution History
                </h5>
            </CardHeader>

            <CardBody className="p-0">
                {usageHistory.length === 0 ? (
                    <div className="p-4 text-center text-muted">
                        No execution history available for this tool.
                    </div>
                ) : (
                    <Table
                        responsive
                        className="mb-0"
                    >
                        <thead className="bg-light">
                            <tr>
                                <th style={{ width: '60px' }}>ID</th>
                                <th style={{ width: '140px' }}>User</th>
                                <th>Details</th>
                                <th style={{ width: '180px' }}>Execution Date & Time</th>
                                <th
                                    style={{ width: '80px' }}
                                    className="text-center"
                                >
                                    Result
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {displayedHistory.map((record) => {
                                const normalizedRecord = {
                                    ...record,
                                    input: record?.input ?? {},
                                    output: record?.output ?? {},
                                };
                                const errorMessage = normalizedRecord.output?.message;

                                return (
                                    <tr key={record.id}>
                                        <td className="align-middle">
                                            <Badge
                                                color="secondary"
                                                pill
                                            >
                                                {record.id}
                                            </Badge>
                                        </td>

                                        <td className="align-middle">{record.userName}</td>

                                        <td>
                                            <div className="small">
                                                {renderRecordDetails?.(normalizedRecord)}
                                            </div>

                                            {Boolean(errorMessage) && (
                                                <div className="text-danger small mt-1">
                                                    <strong>Error:</strong>
                                                    {' '}
                                                    {errorMessage}
                                                </div>
                                            )}
                                        </td>

                                        <td className="align-middle small text-muted">
                                            {formatDate(record.executionDateTime)}
                                        </td>

                                        <td className="align-middle text-center">
                                            {record.isSucceed ? (
                                                <FontAwesomeIcon
                                                    icon={faCheck}
                                                    className="text-success"
                                                />
                                            ) : (
                                                <FontAwesomeIcon
                                                    icon={faTriangleExclamation}
                                                    className="text-danger"
                                                />
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                )}

                {hasMore && (
                    <div className="p-2 text-center text-muted small border-top">
                        Showing {maxRows} of {usageHistory.length} records
                    </div>
                )}
            </CardBody>
        </Card>
    );
};
